import React, { useEffect } from 'react';
import withTranslate from 'components/withTranslate';
import Icon from 'components/icons/Icon';
import PropTypes from 'prop-types';
import { LANGUAGE_TO_BCP47 } from 'data/supported-languages';

export const LanguageDropdown = ({
  availableLanguages,
  currentLanguage,
  setCurrentLanguage,
  abbreviations,
  isLoggedIn,
  _t,
}) => {
  useEffect(() => {
    const bcp47 = LANGUAGE_TO_BCP47[currentLanguage];
    if (bcp47 === undefined && process.env.NODE_ENV !== 'production') {
      console.warn(
        `LanguageDropdown: no BCP 47 tag found for language "${currentLanguage}". ` +
          'Add it to LANGUAGES in data/supported-languages.js.',
      );
    }
    document.documentElement.lang = bcp47 ?? 'en';
  }, [currentLanguage]);

  const handleChange = (e) => {
    setCurrentLanguage(e.target.value, isLoggedIn);
  };

  function getAbbreviation(language) {
    return abbreviations[language] || '??';
  }

  return (
    <div className="language-dropdown">
      <Icon type="globe" className="nav-globe-icon" />
      <label htmlFor="languages">{_t('Languages')}</label>
      <select onChange={handleChange} id="languages" value={currentLanguage}>
        <option disabled className="languages-title">
          {_t('Languages')}
        </option>
        {availableLanguages.map((availableLanguage, index) => (
          <option
            key={index}
            value={availableLanguage.language}
            className="available-languages"
          >
            {getAbbreviation(availableLanguage.language).toUpperCase()} -{' '}
            {_t(availableLanguage.language)}
          </option>
        ))}
      </select>
    </div>
  );
};

export default withTranslate(LanguageDropdown);

LanguageDropdown.propTypes = {
  availableLanguages: PropTypes.arrayOf(
    PropTypes.shape({
      language: PropTypes.string,
      description: PropTypes.string,
    }),
  ),
  currentLanguage: PropTypes.string.isRequired,
  setCurrentLanguage: PropTypes.func.isRequired,
  _t: PropTypes.func.isRequired,
  abbreviations: PropTypes.object,
  isLoggedIn: PropTypes.bool,
};
